"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.renderBmStaticLabelItem = exports.registerStaticLabelElement = exports.BmStaticLabelElement = void 0;

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/taggedTemplateLiteral"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _element = require("@blue/element");

var _fieldStyles = require("../../../../core/render/field-styles");

var _itemRenderer = require("../../../../core/render/items/item-engine/item-renderer");

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)([" <bm-static-label-element .info=\"", "\"></bm-static-label-element> "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t\t.label {\n\t\t\t\t\tmargin: 0;\n\t\t\t\t}\n\t\t\t"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t", "\n\t\t"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var BmStaticLabelElement = /*#__PURE__*/function (_BmItemElement) {
  (0, _inherits2.default)(BmStaticLabelElement, _BmItemElement);

  var _super = (0, _createSuper2.default)(BmStaticLabelElement);

  function BmStaticLabelElement() {
    (0, _classCallCheck2.default)(this, BmStaticLabelElement);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(BmStaticLabelElement, [{
    key: "render",
    value: function render() {
      var _context, _context2, _context3;

      return this.html(_templateObject(), (0, _element.unsafeHTML)((0, _concat.default)(_context = (0, _concat.default)(_context2 = (0, _concat.default)(_context3 = "\n\t\t\t\t\t<".concat(this._getTag(this.info.options.type), "\n\t\t\t\t\t\tclass=\"")).call(_context3, this._getClasses(), "\">\n\t\t\t\t\t\t")).call(_context2, this.info.options.label || '', "\n\t\t\t\t\t</")).call(_context, this._getTag(this.info.options.type), ">")));
    }
  }, {
    key: "_getTag",
    value: function _getTag(type) {
      switch (type) {
        case 'bm-form-label':
          return 'span';

        case 'bm-form-description':
          return 'p';

        case 'bm-form-small-title':
        case 'bm-form-large-title':
          return 'h1';

        default:
          return 'span';
      }
    }
  }, {
    key: "_getClasses",
    value: function _getClasses() {
      var _context4;

      var _this$info$options = this.info.options,
          type = _this$info$options.type,
          styles = _this$info$options.styles;
      return (0, _concat.default)(_context4 = "label ".concat(type, " ")).call(_context4, styles === 'bold' ? 'bm-bold' : '');
    }
  }], [{
    key: "is",
    get: function get() {
      return 'bm-static-label-element';
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        info: {
          type: Object,
          attribute: false,
          reflect: false
        }
      };
    }
  }, {
    key: "styles",
    get: function get() {
      return [_fieldStyles.bmLabelStyles, (0, _element.css)(_templateObject2())];
    }
  }]);
  return BmStaticLabelElement;
}(_itemRenderer.BmItemElement);

exports.BmStaticLabelElement = BmStaticLabelElement;

var registerStaticLabelElement = function registerStaticLabelElement() {
  (0, _element.register)(BmStaticLabelElement);
};

exports.registerStaticLabelElement = registerStaticLabelElement;

var renderBmStaticLabelItem = function renderBmStaticLabelItem(info) {
  return (0, _element.html)(_templateObject3(), info);
};

exports.renderBmStaticLabelItem = renderBmStaticLabelItem;
